import { type EdgeProps, getBezierPath } from "@xyflow/react";
import { type FC, memo } from "react";

export const WorkflowPreviewEdge: FC<EdgeProps> = memo(function ActivityEdge(props) {
  const { sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition, selected, data } = props;
  const [edgePath] = getBezierPath({
    sourceX: sourceX + 5,
    sourceY,
    targetX: targetX - 5,
    targetY,
    sourcePosition,
    targetPosition,
  });

  return (
    <g className={selected ? "selected" : data?.disabled ? "disabled" : undefined} data-edge-disabled={data?.disabled}>
      <path fill="none" stroke="#46769a" strokeWidth={selected ? 2.5 : 1.25} d={edgePath} />
      {/* For the selection of the edge */}
      <path fill="none" strokeOpacity={0} strokeWidth={15} d={edgePath} />
      <rect x={sourceX + 5} y={sourceY - 2.5} fill="#46769A" width="2" height="5" />
      <rect x={targetX - 7} y={targetY - 2.5} fill="#46769A" width="2" height="5" />
    </g>
  );
});
